import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';

import './RichTextEditor.scss';

const editorConfiguration = {
  toolbar: [
    'heading',
    '|',
    'bold',
    'italic',
    'link',
    'bulletedList',
    'numberedList',
    'blockQuote',
    'code',
    '|',
    'undo',
    'redo'
  ]
};

function RichTextEditor({ editorText, setEditorText }) {
  return (
    <div className="rich-text-editor--container">
      <CKEditor
        editor={Editor}
        data={editorText}
        config={editorConfiguration}
        onChange={(event, editor) => {
          const data = editor.getData();
          setEditorText(data);
        }}
      />
    </div>
  );
}

export default RichTextEditor;
